export interface BillingCoverageInput {
  cost: number;
  creditTotal: number;
}

export interface BillingCoverage {
  sufficient: boolean;
  source: "points" | "none";
  /** 本次所需积分。 */
  required: number;
  /** 当前可用积分。 */
  remaining: number;
  shortfall: number;
}

/**
 * 复刻后端 accounts.charge 的单一积分决策:余额大于等于价格即可用。
 * 积分只能用于站内服务,不存在现金/次数包两套支付池。
 */
export function resolveBillingCoverage(input: BillingCoverageInput): BillingCoverage {
  const cost = Math.max(0, Math.trunc(input.cost));
  const creditTotal = Math.max(0, Math.trunc(input.creditTotal));

  if (creditTotal >= cost) {
    return {
      sufficient: true,
      source: "points",
      required: cost,
      remaining: creditTotal,
      shortfall: 0,
    };
  }

  return {
    sufficient: false,
    source: "none",
    required: cost,
    remaining: creditTotal,
    shortfall: Math.max(0, cost - creditTotal),
  };
}
